import React from "react";
import { FaWhatsapp, FaPhone, FaCar, FaStar, FaArrowRight } from "react-icons/fa";
import "../style.css";

const TaxiFleetSection = () => {
  const taxiData = [
    {
      id: 1,
     name: "Maruti Ertiga",
      tag: "Premium Fleet",
      description: "Looking for a reliable 7-seater car in Varanasi? Our Maruti Ertiga MPV offers the perfect blend of comfort and affordability.",
      prices: { airport: "Rs. 1300", "8hr": "Rs. 2300", "12hr": "Rs. 3000", outstation: "Rs. 15/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tavera-Ertiga.jpg"
    },
    {
      id: 2,
     name: "Swift Dzire",
      tag: "Premium Fleet",
      description: "Experience Varanasi with our affordable 4-seater sedan taxi service – ideal for city tours, family travel, business trips, and airport transfers.",
      prices: { airport: "Rs. 1500", "8hr": "Rs. 2000", "12hr": "Rs. 2500", outstation: "Rs. 12/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Swift-Dzire.jpg"
     
    },
    {
      id: 3,
        name: "Toyota Innova",
      tag: "Premium Fleet",
      description: "Trusted 7-seater SUV for local city rides, corporate meetings, airport pickups, and long-distance travel.",
      prices: { airport: "Rs. 1400", "8hr": "Rs. 2500", "12hr": "Rs. 3200", outstation: "Rs. 16/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Innova.jpg"
      
    },
    {
      id: 4,
       name: "Tempo Traveller 17 Seater",
      tag: "Premium Fleet",
      description: "Spacious minibus with 17 seats, best choice for large groups and long-distance trips.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3000", "12hr": "Rs. 4000", outstation: "Rs. 25/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Tempo-Traveller.jpg"
    },
    {
      id: 5,
        name: "Toyota Crysta",
      tag: "Premium Fleet",
      description: "Looking for a luxury cab in Varanasi? Our Toyota Crysta offers unmatched comfort and reliability.",
      prices: { airport: "Rs. 1600", "8hr": "Rs. 3000", "12hr": "Rs. 4000", outstation: "Rs. 20/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Toyota-Crysta.jpg"
    },
    {
      id: 6,
       name: "Honda City",
      tag: "Premium Fleet",
      description: "Luxury 4-seater sedan ideal for business travel, premium city rides, and smooth airport pickups.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3200", "12hr": "Rs. 4000", outstation: "Rs. 22/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Honda-City.jpg"
    },
    {
      id: 7,
       name: "Cruiser 10-13 Seater",
      tag: "Premium Fleet",
      description: "Perfect for medium-sized groups, offering comfort, reliability, and affordable fares for sightseeing, events, and city rides.",
      prices: { airport: "Rs. 2000", "8hr": "Rs. 3500", "12hr": "Rs. 4500", outstation: "Rs. 20/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/Cruiser-13-Seater.jpg"
    },
    {
      id: 8,
      name: "Urbania 16 Seater",
      tag: "Premium Fleet",
      description: "Modern luxury van with 16 seats, designed for ultimate comfort and premium group travel.",
      prices: { airport: "Rs. 3500", "8hr": "Rs. 4500", "12hr": "Rs. 7500", outstation: "Rs. 34/KM" },
      details: { "8hr": "8Hr / 80KM", "12hr": "12Hr / 120KM" },
      image: "https://dsicbusfpgkzqwgsvkww.supabase.co/storage/v1/object/public/bucket0/urbania-trav.png"
    
    }
  ];

  const handleBookNow = (carName) => {
    alert(`Booking request for ${carName}`);
  };

  const handleCall = () => {
    alert("Calling customer service...");
  };

  const handleWhatsApp = () => {
    alert("Opening WhatsApp...");
  };

  return (
    <section className="taxi-fleet-section">
      <div className="taxi-fleet-container">
        <div className="taxi-fleet-header">
          <h2 className="taxi-title-animation">Taxi Rental in Kashi</h2>
          <p className="taxi-subtitle-animation">
            Choose from our premium fleet of sedans, SUVs, and luxury travellers for your perfect journey in Kashi.
          </p>
        </div>

        <div className="taxi-fleet-grid">
          {taxiData.map((taxi, index) => (
            <div
              key={taxi.id}
              className="taxi-fleet-card taxi-card-animation"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="taxi-image-container">
                <img 
                  src={taxi.image} 
                  alt={taxi.name}
                  className="taxi-image"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/400x250?text=Taxi+Image";
                  }}
                />
                <div className="taxi-tag">
                  <FaStar className="tag-icon" /> {taxi.tag}
                </div>
              </div>
              
              <div className="taxi-content">
                <h3 className="taxi-name">{taxi.name}</h3>
                <p className="taxi-description">{taxi.description}</p>

                <div className="taxi-pricing-grid">
                  <div className="price-item">
                    <span className="price-label">Airport</span>
                    <span className="price-value">{taxi.prices.airport}</span>
                  </div>
                  <div className="price-item">
                    <span className="price-label">{taxi.details["8hr"]}</span>
                    <span className="price-value">{taxi.prices["8hr"]}</span>
                  </div>
                  <div className="price-item">
                    <span className="price-label">{taxi.details["12hr"]}</span>
                    <span className="price-value">{taxi.prices["12hr"]}</span>
                  </div>
                  <div className="price-item">
                    <span className="price-label">Outstation</span>
                    <span className="price-value">{taxi.prices.outstation}</span>
                  </div>
                </div>

                <div className="taxi-action-buttons">
                  <button
                    className="taxi-btn taxi-whatsapp-btn"
                    onClick={() => handleWhatsApp()}
                    title="WhatsApp"
                  >
                    <FaWhatsapp className="btn-icon" />
                  </button>
                  
                  <button 
                    className="taxi-btn taxi-call-btn"
                    onClick={() => handleCall()}
                    title="Call"
                  >
                    <FaPhone className="btn-icon" />
                  </button>
                  
                  <button
                    className="taxi-btn taxi-book-btn"
                    onClick={() => handleBookNow(taxi.name)}
                    
                    title="Book Now"
                  >
                    Book Now
                    <FaArrowRight className="arrow-icon" />
                  </button>
                </div>
              </div>
              
              {/* Animated gradient border */}
              <div className="card-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaxiFleetSection;